import { __assign, __makeTemplateObject } from "tslib";
import React from 'react';
import styled from 'styled-components';
import { layout, color, space } from 'styled-system';
import { cursor, fill, hoverColor, hoverFill, transition, } from '../customProperties';
import { getDOMProps } from '../utils';
export var Svg = styled(function (props) { return React.createElement("svg", __assign({}, getDOMProps(props))); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  &:hover {\n    ", ";\n    ", ";\n  }\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  &:hover {\n    ", ";\n    ", ";\n  }\n"])), color, cursor, fill, layout, space, transition, hoverColor, hoverFill);
var templateObject_1;
